/* eslint no-param-reassign: [2, { "props": false }] */

import * as types from './mutation-types';

export default {
  [types.UPDATE_AUCTIONS_CATALOG](state, { auctionsCatalog }) {
    state.auctionsCatalog = auctionsCatalog;
  },

  [types.UPDATE_ARTWORKS](state, { artworks }) {
    state.artworks = artworks;
  },

  [types.UPDATE_META](state, { meta }) {
    state.meta = meta;
  },

  [types.SET_CURRENT_USER_ID](state, userId) {
    state.userId = userId;
  },

  [types.SET_MEMORISE_STATE](state, artworkId) {
    const artworks = state.artworks;
    const artwork = artworks.find(elem => elem.id === artworkId);

    artwork.memorised = !artwork.memorised;
  },
};



// WEBPACK FOOTER //
// ./app/javascript/packs/auctions_catalogs/show/store/mutations.js